/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import AssignmentIcon from '@material-ui/icons/Assignment';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import EventIcon from '@material-ui/icons/Event';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import MemoryIcon from '@material-ui/icons/Memory';
import TruePortIcon from '@material-ui/icons/AccessibilityNew';
import TrueScanIcon from '@material-ui/icons/BusinessCenter';
import DashboardIcon from '@material-ui/icons/Dashboard';
import NextWeek from '@material-ui/icons/NextWeek';
import MonitorIcon from '@material-ui/icons/Pageview';
import {
  CELL_LOG_ENTRIES_VIEW,
  CELL_WALKS_VIEW,
  CELLS_CONFIG_UPDATE,
  CELLS_VIEW,
  CUSTOMER_EVENTS_VIEW,
  CUSTOMERS_VIEW,
  EVENT_DATA_SETS_VIEW,
  EVENT_MODEL_RUN_REQUESTS_VIEW,
  EVENT_MODEL_WORKERS_VIEW,
  MODEL_CONFIGURATIONS_VIEW,
  MODEL_SETS_VIEW,
  PARTICIPANTS_VIEW,
  PORTAL_USERS_VIEW,
  SOFTWARE_PACKAGES_VIEW,
  TEST_SCENARIOS_VIEW,
  TEST_SESSION_ANALYSIS_VIEW,
  TEST_SESSION_GROUPS_VIEW,
  TEST_SESSIONS_VIEW,
  TRAINING_SCENARIOS_VIEW,
  TRAINING_SESSIONS_VIEW,
  VENUES_VIEW,
  INTEGRATION_PARTNERS_VIEW,
  INVENTORY_COUNTS_VIEW,
  KNOWN_CARRIERS_VIEW,
  TRUE_SCAN_VIEW,
  SCANS_VIEW,
  QUOTE_TOOL_UPLOAD,
  HEVO_STATUS_VIEW,
  VENUE_WEBHOOKS_VIEW
} from 'common/Right';
import ws from 'utils/ws';

export default [
  {
    title: null,
    pages: [
      {
        title: 'Dashboards',
        href: '/org/dashboard/',
        rights: [CELL_WALKS_VIEW],
        icon: DashboardIcon,
        children: [
          {
            title: 'Organization',
            href: '/org/dashboard/',
            right: CELL_WALKS_VIEW
          }
        ]
      },
      {
        title: 'Events',
        href: '/events',
        rights: [CUSTOMER_EVENTS_VIEW],
        icon: EventIcon,
        children: [
          {
            title: 'Calendar',
            href: '/events/calendar/',
            right: CUSTOMER_EVENTS_VIEW
          },
          {
            title: 'Customer Events',
            href: '/events/customer_events/',
            right: CUSTOMER_EVENTS_VIEW
          }
        ]
      },
      {
        title: 'Monitoring',
        href: '/monitor',
        rights: [CUSTOMER_EVENTS_VIEW],
        icon: MonitorIcon,
        children: [
          {
            title: 'Venues',
            href: '/monitor/venues/',
            right: CUSTOMER_EVENTS_VIEW
          },
          {
            title: 'Critical Device Logs',
            href: '/monitor/device_logs/',
            right: CELLS_VIEW
          },
          {
            title: 'Customer Devices',
            href: '/monitor/device_sub_status_summary/',
            right: CELLS_VIEW
          }
        ]
      },
      {
        title: 'Walks',
        href: '/walks',
        rights: [CELL_WALKS_VIEW],
        icon: DirectionsWalkIcon,
        children: [
          {
            title: 'Walks',
            href: '/walks/cell_walks/',
            right: CELL_WALKS_VIEW
          },
          {
            type: 'external',
            title: 'Warehouse',
            href: ws.insight2Url('/walks/warehouse/'),
            right: CELL_WALKS_VIEW
          },
          {
            title: 'Walk Collections',
            href: '/walks/data_sets/',
            right: EVENT_DATA_SETS_VIEW
          },
          {
            title: 'Analysis',
            href: '/walks/analysis/',
            right: TEST_SESSION_ANALYSIS_VIEW
          }
        ]
      },
      {
        title: 'Scans',
        href: '/scans',
        rights: [SCANS_VIEW],
        icon: NextWeek,
        children: [
          {
            title: 'Scans',
            href: '/scans/device_scans/',
            right: SCANS_VIEW
          }
        ]
      },
      {
        title: 'Testing',
        href: '/testing',
        rights: [
          TEST_SCENARIOS_VIEW,
          TEST_SESSIONS_VIEW,
          TEST_SESSION_GROUPS_VIEW,
          TEST_SESSION_ANALYSIS_VIEW
        ],
        icon: AssignmentIcon,
        children: [
          {
            title: 'Sessions',
            href: '/testing/sessions/',
            right: TEST_SESSIONS_VIEW
          },
          {
            title: 'Scenarios',
            href: '/testing/scenarios/',
            right: TEST_SCENARIOS_VIEW
          }
        ]
      },
      {
        title: 'Data Collection',
        href: '/training',
        rights: [TRAINING_SCENARIOS_VIEW, TRAINING_SESSIONS_VIEW],
        icon: HowToRegIcon,
        children: [
          {
            title: 'Sessions',
            href: '/training/sessions/',
            right: TRAINING_SESSIONS_VIEW
          },
          {
            title: 'Scenarios',
            href: '/training/scenarios/',
            right: TRAINING_SCENARIOS_VIEW
          },
          {
            title: 'Cells',
            href: '/training/cells_overview/',
            right: TRAINING_SESSIONS_VIEW
          }
        ]
      },
      {
        title: 'TruePort®',
        href: '/deployment',
        rights: [CELLS_VIEW],
        icon: TruePortIcon,
        children: [
          {
            title: 'Devices',
            href: '/deployment/cells/',
            right: CELLS_VIEW
          },
          {
            title: 'Inventory Counts',
            href: '/deployment/inventory_counts/',
            right: INVENTORY_COUNTS_VIEW
          },
          {
            title: 'Software',
            href: '/deployment/software_installations/',
            right: SOFTWARE_PACKAGES_VIEW
          },
          {
            title: 'Critical Logs',
            href: '/deployment/cell_log_entries/',
            right: CELL_LOG_ENTRIES_VIEW
          },
          {
            title: 'Map',
            href: '/deployment/cells_map',
            right: CELLS_VIEW
          },
          {
            title: 'Configuration',
            href: '/deployment/cell_config/',
            right: CELLS_CONFIG_UPDATE
          }
        ]
      },
      {
        title: 'TrueScan®',
        href: '/true_scan',
        rights: [TRUE_SCAN_VIEW, SCANS_VIEW],
        icon: TrueScanIcon,
        children: [
          {
            title: 'Devices',
            href: '/true_scan/devices/',
            right: TRUE_SCAN_VIEW
          },
          {
            title: 'Inventory Counts',
            href: '/true_scan/inventory_counts/',
            right: INVENTORY_COUNTS_VIEW
          },
          {
            title: 'Software',
            href: '/true_scan/software_installations/',
            right: TRUE_SCAN_VIEW
          }
        ]
      },
      {
        title: 'Modelling',
        href: '/models',
        rights: [MODEL_CONFIGURATIONS_VIEW],
        icon: MemoryIcon,
        children: [
          {
            title: 'Models',
            href: '/models/model_configurations/',
            right: MODEL_CONFIGURATIONS_VIEW
          },
          {
            title: 'Model Sets',
            href: '/models/model_sets/',
            right: MODEL_SETS_VIEW
          },
          {
            title: 'Collections Analysis',
            href: '/models/collections_analysis/',
            right: MODEL_CONFIGURATIONS_VIEW
          },
          {
            title: 'NAS Files',
            href: '/models/walks_local_storage/',
            right: MODEL_CONFIGURATIONS_VIEW
          }
        ]
      },
      {
        title: 'Reference',
        href: '/reference',
        rights: [
          PARTICIPANTS_VIEW,
          QUOTE_TOOL_UPLOAD,
          HEVO_STATUS_VIEW,
          VENUE_WEBHOOKS_VIEW
        ],
        icon: LibraryBooksIcon,
        children: [
          {
            title: 'Participants',
            href: '/reference/participants/',
            right: PARTICIPANTS_VIEW
          },
          {
            title: 'Customers',
            href: '/reference/customers/',
            right: CUSTOMERS_VIEW
          },
          {
            title: 'Venues',
            href: '/reference/venues/',
            right: VENUES_VIEW
          },
          {
            title: 'Integration Partners',
            href: '/reference/integration_partners/',
            right: INTEGRATION_PARTNERS_VIEW
          },
          {
            title: 'Portal Users',
            href: '/reference/portal_users/',
            right: PORTAL_USERS_VIEW
          },
          {
            title: 'Known Carriers',
            href: '/reference/known_carriers/',
            right: KNOWN_CARRIERS_VIEW
          },
          {
            title: 'Quote Tool',
            href: '/reference/quote_tool/',
            right: QUOTE_TOOL_UPLOAD
          },
          {
            title: 'Hevo Status',
            href: '/reference/hevo_status/',
            right: HEVO_STATUS_VIEW
          },
          {
            title: 'Webhooks',
            href: '/reference/webhooks/',
            right: VENUE_WEBHOOKS_VIEW
          }
        ]
      }
    ]
  }
];
